import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Message, Form } from '@alifd/next';
import { history } from 'ice';
import { useInterval } from './utils';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
const { Item } = Form;

export default function RegisterBlock() {
  const [postData, setValue] = useState({
    email: '',
    password: '',
    rePassword: '',
    name: '',
    // code: '',
  });
  const [isRunning, checkRunning] = useState(false);
  const [second, setSecond] = useState(59);
  useInterval(
    () => {
      setSecond(second - 1);

      if (second <= 0) {
        checkRunning(false);
        setSecond(59);
      }
    },
    isRunning ? 1000 : null,
  );

  const formChange = value => {
    // console.log(value)
    setValue(value);
  };



  const sendCode = (values, errors) => {
    if (errors) {
      return;
    } // get values.phone

    checkRunning(true);
  };

  const checkPass = (rule, values, callback) => {
    if (values && values !== postData.password) {
      return callback('密碼不一致');
    }
    return callback();
  };


  const handleSubmit = (values, errors) => {
    if (errors) {
      console.log('errors', errors);
      return;
    }
    console.log('values:', values);
    const users = client.service('users');
    users.create({ email: values.email, name: values.name, password: values.password }).then(obj => {
      console.log('==users create result:', obj)
      Message.success('註冊成功，請使用新帳號密碼登入');
      if (history.location.pathname === `/mobile/user/register`) {
        history.push('/mobile/user/login');
      } else {
        history.push('/user/login')
      }
    }).catch(err => {
      console.log('==users create fail:', err)
      Message.error(`${err}`);

      // if(err.errorType==='FeathersError')
      //   Message.error('註冊失敗：帳號已存在');
      // else
      //   Message.error('註冊失敗：'+err.errorType);
    })

  };


  return (
    <>
      {history.location.pathname === `/mobile/user/register` ?
        <div className={styles.mobileRegister}>
          <div className={styles.mobileRegisterBackground} />
          <div className={styles.mobileRegisterContainer}>
         
              <div className={styles.mobileAccountText}>註冊帳號</div>

              <Form value={postData} onChange={formChange} size="large">
                <Item format="email" required requiredMessage="必填">
                  <Input name="email" size="large" maxLength={100} placeholder="電子信箱" />
                </Item>
                <Item required requiredMessage="必填">
                  <Input name="name" size="large" maxLength={10} placeholder="用戶名" />
                </Item>
                <Item required requiredMessage="必填">
                  <Input.Password
                    name="password"
                    size="large"
                    htmlType="password"
                    placeholder="至少6位數字"
                  />
                </Item>
                <Item required requiredTrigger="onFocus" requiredMessage="必填" validator={checkPass}>
                  <Input.Password
                    name="rePassword"
                    size="large"
                    htmlType="password"
                    placeholder="確認密碼"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSubmit(postData)
                      }
                    }}
                  />
                </Item>
               
                <Item>
                  <Form.Submit
                    type="primary"
                    onClick={handleSubmit}
                    className={styles.mobileSubmitBtn}
                    validate
                  >
                    註冊
            </Form.Submit>

                </Item>

                <Item
                  style={{
                    textAlign: 'end',
                  }}
                >
                  <a onClick={() => {
                    if (history.location.pathname === `/mobile/user/register`) {
                      history.push('/mobile/user/login');
                    } else {
                      history.push('/user/login')
                    }

                  }} className={styles.mobileLink}>
                    使用現有帳號登入
            </a>
                </Item>
              </Form>
            
          </div>
        </div>
        :
        <div className={styles.RegisterBlock}>
          <div className={styles.innerBlock}>
            {/* <a href="#">
          <img
            className={styles.logo}
            src="https://img.alicdn.com/tfs/TB1KtN6mKH2gK0jSZJnXXaT1FXa-1014-200.png"
            alt="logo"
          />
        </a> */}
            <p className={styles.desc}>註冊帳號</p>

            <Form value={postData} onChange={formChange} size="large">
              <Item format="email" required requiredMessage="必填">
                <Input name="email" size="large" maxLength={100} placeholder="電子信箱" />
              </Item>
              <Item required requiredMessage="必填">
                <Input name="name" size="large" maxLength={10} placeholder="用戶名" />
              </Item>
              <Item required requiredMessage="必填">
                <Input.Password
                  name="password"
                  size="large"
                  htmlType="password"
                  placeholder="至少6位數字"
                />
              </Item>
              <Item required requiredTrigger="onFocus" requiredMessage="必填" validator={checkPass}>
                <Input.Password
                  name="rePassword"
                  size="large"
                  htmlType="password"
                  placeholder="確認密碼"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSubmit(postData)
                    }
                  }}
                />
              </Item>
              {/* <Item format="tel" required requiredMessage="必填" asterisk={false}>
            <Input
              name="phone"
              size="large"
              innerBefore={
                <span className={styles.innerBeforeInput}>
                  +86
                  <span className={styles.line} />
                </span>
              }
              maxLength={20}
              placeholder="手机号"
            />
          </Item> */}
              {/* <Item required requiredMessage="必填">
            <Input
              name="code"
              size="large"
              innerAfter={
                <span className={styles.innerAfterInput}>
                  <span className={styles.line} />
                  <Form.Submit
                    text
                    type="primary"
                    style={{
                      width: 64,
                    }}
                    disabled={!!isRunning}
                    validate={['phone']}
                    onClick={sendCode}
                    className={styles.sendCode}
                  >
                    {isRunning ? `${second}秒后再试` : '获取验证码'}
                  </Form.Submit>
                </span>
              }
              maxLength={20}
              placeholder="验证码"
            />
          </Item> */}
              <Item>
                <Form.Submit
                  type="primary"
                  onClick={handleSubmit}
                  className={styles.submitBtn}
                  validate
                >
                  註冊
            </Form.Submit>

              </Item>
              <Item
                style={{
                  textAlign: 'center',
                }}
              >
                <a onClick={() => {
                  if (history.location.pathname === `/mobile/user/register`) {
                    history.push('/mobile/user/login');
                  } else {
                    history.push('/user/login')
                  }

                }} className={styles.link}>
                  使用現有帳號登入
            </a>
              </Item>
            </Form>
          </div>
        </div>}
    </>);
}
RegisterBlock.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  value: PropTypes.object,
};
RegisterBlock.defaultProps = {
  value: {},
};
